export default {
    'brand-change-requests': 'Brand changes',
    resource: 'Brand change',

    id: 'ID',
    title: 'Name',
    slug: 'Slug',
    url: 'URL',
    image: 'Image',
    where_to_find: 'Location',
    description: 'Description',
    delete: 'Delete',
};
